import React, { useImperativeHandle, useState, useRef, useEffect } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Pager, Paging } from "devextreme-react/data-grid";
import 'devextreme-react/text-area';
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../utils/media-query";
import OperatoreEditPanel, { OperatoreEditPanelHandle } from "./OperatoreEditPanel";


type Props = {
  onHidden?: () => void;
  onDataChanged?: () => void;
}

export type OperatoreEditPopupHandle = {
  edit: (operatoreId: string, title?: string) => void,
  new: () => void
}

type state = {
  operatoreId?: string,
  visible: boolean
}

const AssistitoEditPopup: React.ForwardRefRenderFunction<OperatoreEditPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ operatoreId: undefined, visible: false  });
  const [popupTitle, setPopupTitle] = useState<string>("Operatore");
  const { isXSmall, isSmall } = useScreenSize();
  const [fullscreen, setFullscreen] = useState(isXSmall || isSmall);
  const operatoreEditPanelRef = useRef<OperatoreEditPanelHandle>(null);

  function hide() {
    setState({ operatoreId: undefined, visible: false });
    props.onHidden?.();
  }

  async function SaveAndClose() {
    if (await operatoreEditPanelRef.current?.save()) {
       props.onDataChanged?.();
      hide();
    }
  }

  useImperativeHandle(ref, () => ({
    edit(operatoreId, title) {
      setState({
        operatoreId: operatoreId,
        visible: true
      });
      if (title)
        setPopupTitle(title);
    },
    new() {
      setState({
        operatoreId: undefined,
        visible: true
      });
    }
  }));

  return (
    <React.Fragment>
      {state.visible &&
      <Popup
        visible={true}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={true}
        fullScreen={fullscreen}
        showTitle={true}
        onHidden={hide}
        title={popupTitle}
        container=".dx-viewport"
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          //visible={!(isXSmall || isSmall)}  
          options={{
            icon: 'fullscreen',
            onClick: () => setFullscreen(!fullscreen),
          }}
        />
         <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={{
            text: 'Salva',
            type: 'default',
            stylingMode: 'contained',
            onClick: SaveAndClose
          }}
        />
         <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={{
            text: 'Annulla',
            type: 'normal',
            stylingMode: 'contained',
            onClick: hide
          }}
        />
       
        <OperatoreEditPanel ref={operatoreEditPanelRef} operatoreId={state.operatoreId}  />
      </Popup>
      }
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditPopup);
